/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Templates_Upload_HintInputs */

const cs_social_templates_upload_hint = /** @type {(inputs: Social_Templates_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soubor .typ musí číst social_post.v1 data.json (stejná pole jako u katalogového listu).`)
};

const en_social_templates_upload_hint = /** @type {(inputs: Social_Templates_Upload_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Provide a .typ file that reads social_post.v1 data.json (same fields as catalog hero/title/price).`)
};

/**
* | output |
* | --- |
* | "Provide a .typ file that reads social_post.v1 data.json (same fields as catalog hero/title/price)." |
*
* @param {Social_Templates_Upload_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_templates_upload_hint = /** @type {((inputs?: Social_Templates_Upload_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Templates_Upload_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_templates_upload_hint(inputs)
	return cs_social_templates_upload_hint(inputs)
});